import axios from 'axios';
//import qs from 'qs';
import store from '@/store';




export const instance = axios.create({
	baseURL: '/api',
	timeout: 30000,
	withCredentials: true,
	responseType: 'json',
	headers: {'content-type': 'application/json'},
	/*transformRequest: function (data, headers) {
		// Do whatever you want to transform the data

		if (typeof data === 'object' && headers['content-type'] !== 'application/json') {

			data.token = store.getters.csrf_token;
			data = qs.stringify(data, {arrayFormat: 'brackets'});

		}else if(typeof data === 'undefined'){
			/!*data = {
				token: store.getters.csrf_token
			};*!/
			data = qs.stringify(data, {arrayFormat: 'brackets'});
		}

		return data;
	}*/
});

instance.interceptors.request.use(null, function (error) {
	return Promise.reject(error);
});

instance.interceptors.response.use( function (response) {

	//Update CSRF token
	if(response.data){
		if(response.data.last_token){
			//Get token from root
			store.commit('setCSRFtoken', response.data.last_token);
		}
	}
	return response;

}, function(error){

	//debugger;
	if(error.request && error.request.status === 401){
		store.commit('clearUser');
	}
	return Promise.reject(error);

});



export const api = {
	user:{
		login: '/login',
		logout: '/logout',
		refresh: '/islogin'
	},
	streams:{
		chanels: '/stream',
		stream: '/stream/', // /stream/{chanel_is}
		track: '/stream/track/', // /stream/track/{track_id}
	}
};